"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitErrorModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _DialogContent = require("../../primitives/DialogContent");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var InitErrorModal = function InitErrorModal(_ref) {
  var notification = _ref.notification;
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = (0, _react.useState)({
      title: "Init Error",
      description: ""
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    info = _useState4[0],
    setInfo = _useState4[1];
  (0, _react.useEffect)(function () {
    var data = notification === null || notification === void 0 ? void 0 : notification.data;
    if (!data || data.action !== "INIT") {
      return;
    }
    var description;
    var title;
    if (data.description.includes("role is invalid")) {
      description = "This role does not exist for the given room. Try again with a valid role.";
      title = "Invalid Role";
    } else if (data.description.includes("room is not active")) {
      title = "Meeting ended";
      description = "We couldn't connect you because the meeting ended.";
    } else if (data.description.includes("token is expired")) {
      title = "Token expired.";
      description = "We couldn't connect you because the token has expired. If you're still on your meeting time, please try to join again. Please reach out to support if you continue to see this error.";
    } else {
      description = data.description;
      title = "Init Error";
    }
    setInfo({
      title: title,
      description: description
    });
    setShowModal(true);
  }, [notification]);
  var handleOkay = function handleOkay() {
    navigate("/consultation/".concat(sessionId));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.ErrorDialog, {
    open: showModal,
    onOpenChange: setShowModal,
    title: info.title,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "sm",
      css: {
        wordBreak: "break-word"
      },
      children: info.description
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      justify: "end",
      align: "end",
      css: {
        paddingTop: "20px"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
        onClick: handleOkay,
        children: "Okay"
      })
    })]
  });
};
exports.InitErrorModal = InitErrorModal;